import React from "react"
import styled from "styled-components"
import dompurify from "dompurify"

export default function WalletComponent(props) {
  return <div className="wallet-buttons-v2__wrapper"></div>
}
